import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthguardDisputeInitiated {

  constructor(private userService: AuthService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    const verifyId: string = route.queryParams['verifyId'];
    if (verifyId != null) {
      sessionStorage.setItem('verifyId', verifyId);
      localStorage.setItem('verifyIdLocal', verifyId);
    } else if (this.userService.getVerifyId() == null) {
      this.router.navigate(['unauthorized']);
    }


    this.userService.getDisputeRegistration().subscribe({
      next: (data: string) => {
        if ("signInView" == data) {
          this.router.navigate(['loginDisputeRegistration']);
        } else if ("submittedView" == data) {
          this.router.navigate(['disputeAlreadySubmitted']);
        } else if ("registrationView" == data) {
          this.router.navigate(['createAccount']);
        } else {
          this.router.navigate(['unauthorized']);
        }
      },
      error: () => {
        this.router.navigate(['unauthorized']);
      }
    });

    return true;
  }

}
